export const FETCH_ENROLLMENT_APPROVAL_REQUEST_HISTORY_PENDING =
  'FETCH_ENROLLMENT_APPROVAL_REQUEST_HISTORY_PENDING'
export const FETCH_ENROLLMENT_APPROVAL_REQUEST_HISTORY_FULFILLED =
  'FETCH_ENROLLMENT_APPROVAL_REQUEST_HISTORY_FULFILLED'
export const FETCH_ENROLLMENT_APPROVAL_REQUEST_HISTORY_REJECTED =
  'FETCH_ENROLLMENT_APPROVAL_REQUEST_HISTORY_REJECTED'

export const FETCH_ANCILLARY_MATERIALS_APPROVAL_REQUEST_HISTORY_PENDING =
  'FETCH_ANCILLARY_MATERIALS_APPROVAL_REQUEST_HISTORY_PENDING'
export const FETCH_ANCILLARY_MATERIALS_APPROVAL_REQUEST_HISTORY_FULFILLED =
  'FETCH_ANCILLARY_MATERIALS_APPROVAL_REQUEST_HISTORY_FULFILLED'
export const FETCH_ANCILLARY_MATERIALS_APPROVAL_REQUEST_HISTORY_REJECTED =
  'FETCH_ANCILLARY_MATERIALS_APPROVAL_REQUEST_HISTORY_REJECTED'

export const FETCH_EXCEPTION_TESTING_APPROVAL_REQUEST_HISTORY_PENDING =
  'FETCH_EXCEPTION_TESTING_APPROVAL_REQUEST_HISTORY_PENDING'
export const FETCH_EXCEPTION_TESTING_APPROVAL_REQUEST_HISTORY_FULFILLED =
  'FETCH_EXCEPTION_TESTING_APPROVAL_REQUEST_HISTORY_FULFILLED'
export const FETCH_EXCEPTION_TESTING_APPROVAL_REQUEST_HISTORY_REJECTED =
  'FETCH_EXCEPTION_TESTING_APPROVAL_REQUEST_HISTORY_REJECTED'

export const FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_PENDING =
  'FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_PENDING'
export const FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_FULFILLED =
  'FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_FULFILLED'
export const FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_REJECTED =
  'FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_REJECTED'

export const FETCH_ORDERS_AFTER_DEADLINE_APPROVAL_REQUEST_HISTORY_PENDING =
  'FETCH_ORDERS_AFTER_DEADLINE_APPROVAL_REQUEST_HISTORY_PENDING'
export const FETCH_ORDERS_AFTER_DEADLINE_APPROVAL_REQUEST_HISTORY_FULFILLED =
  'FETCH_ORDERS_AFTER_DEADLINE_APPROVAL_REQUEST_HISTORY_FULFILLED'
export const FETCH_ORDERS_AFTER_DEADLINE_APPROVAL_REQUEST_HISTORY_REJECTED =
  'FETCH_ORDERS_AFTER_DEADLINE_APPROVAL_REQUEST_HISTORY_REJECTED'

export const FETCH_RESHIPMENTS_APPROVAL_REQUEST_HISTORY_PENDING =
  'FETCH_RESHIPMENTS_APPROVAL_REQUEST_HISTORY_PENDING'
export const FETCH_RESHIPMENTS_APPROVAL_REQUEST_HISTORY_FULFILLED =
  'FETCH_RESHIPMENTS_APPROVAL_REQUEST_HISTORY_FULFILLED'
export const FETCH_RESHIPMENTS_APPROVAL_REQUEST_HISTORY_REJECTED =
  'FETCH_RESHIPMENTS_APPROVAL_REQUEST_HISTORY_REJECTED'
